import { render, staticRenderFns } from "./ReservationAccommodationGeneral.vue?vue&type=template&id=5e4fd4c4&scoped=true&"
import script from "./ReservationAccommodationGeneral.vue?vue&type=script&lang=js&"
export * from "./ReservationAccommodationGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4fd4c4",
  null
  
)

export default component.exports